import { dataInvoice } from 'dls-icons-data'
import { createIcon } from '../common'

const IconInvoice = /*#__PURE__*/createIcon(dataInvoice)
export default IconInvoice
